import { render, staticRenderFns } from "./CollectPlugin.vue?vue&type=template&id=75ae351a&scoped=true&"
import script from "./CollectPlugin.vue?vue&type=script&lang=js&"
export * from "./CollectPlugin.vue?vue&type=script&lang=js&"
import style0 from "./CollectPlugin.vue?vue&type=style&index=0&id=75ae351a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ae351a",
  null
  
)

export default component.exports